
define('ldsh!modules/form_editor/templates/preview_custom_fblogin', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-item-socialbox ed-item-socialbox-h ' +
((__t = ( position )) == null ? '' : __t) +
'">\n  <div id="' +
((__t = ( idName )) == null ? '' : __t) +
'"\n       class="ed-social-block ed-facebook-login fb-login-button size-' +
((__t = ( size )) == null ? '' : __t) +
'"\n       scope="email"\n       data-max-rows="1"\n       data-size="' +
((__t = ( size )) == null ? '' : __t) +
'"\n       data-show-faces="false"\n       data-auto-logout-link="false"\n       onlogin="LPGRuntime.onFacebookLogin();"></div>\n</div>\n';

}
return __p
};});

